<template>
  <div class="frame-template">

    <div v-if="step === 0">
      <a-breadcrumb separator=">">
        <a-breadcrumb-item>图框模板库</a-breadcrumb-item>
      </a-breadcrumb>
      <div class="frame-template-container">
        <div :style="{borderBottom: 'solid 1px #e8e8e8', paddingBottom: '15px'}">
          <a-button type="primary" @click="isProjectEdit = true">新增项目</a-button>
        </div>
        <div class="lately-solution">
          <div class="solution-item" v-for="item in projectData" :key="item.id">
            <div class="thumbnail" @click="_goProjectDetails(item.id, item.name )">
              <img
                :src="
                  item.img
                    ? `${ossPathUrl}/${item.solutionThumbnail}`
                    : require('@/assets/workbench/icon-file.svg')
                "
                alt=""
              />
              <a-dropdown :trigger="['click']">
                <a class="ant-dropdown-link" @click.stop>
                  ...
                </a>
                <a-menu slot="overlay">
                  <a-menu-item key="0">
                    <a-popconfirm title="确定删除吗?" @confirm="() => _handleDeleteNode(item.id, 'project')" placement="bottom">
                      <a>删除</a>
                    </a-popconfirm>
                  </a-menu-item>
                  <a-menu-item key="1" v-if="item.dwgProjectLibraryPublicFlag === 'false'">
                    <a-popconfirm title="确定公开吗?" @confirm="() => _handleEditNode(item, true)" placement="bottom">
                      <a>公开</a>
                    </a-popconfirm>
                  </a-menu-item>
                  <a-menu-item key="2" v-if="item.dwgProjectLibraryPublicFlag ==='true'">
                    <a-popconfirm title="确定取消公开吗?" @confirm="() => _handleEditNode(item, false)" placement="bottom">
                      <a>取消公开</a>
                    </a-popconfirm>
                  </a-menu-item>
                  <a-menu-item key="3">
                    <template>
                      <a-modal
                        class="template-edit"
                        centered
                        width="500px"
                        title="重命名"
                        :visible="isReNameVisible"
                        @ok="_reName(item, 'project')"
                        @cancel="isReNameVisible = false"
                      >
                        <a-form-model-item label="名称" prop="prevName">
                          <a-input v-model="prevName" @change="(e) => prevName = e.target.value" />
                        </a-form-model-item>
                      </a-modal>
                    </template>
                    <a @click="isReNameVisible = true, prevName = item.name">重命名</a>
                  </a-menu-item>
                </a-menu>

              </a-dropdown>
            </div>
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>

    </div>

    <div v-if="step === 1">
      <a-breadcrumb separator=">">
        <a-breadcrumb-item >
          <span @click="step = 0">图框模板库</span>
        </a-breadcrumb-item>
        <a-breadcrumb-item><span>{{ curProjectName }}</span></a-breadcrumb-item>
      </a-breadcrumb>
      <div class="frame-template-container">
        <a-tabs v-model="activeKey" @change="_handleTabChange">
          <a-tab-pane v-for="data in tabLabels" :key="data.id" :tab="data.name" >
            <div>
              <a-button v-if="data.id !== 'drawingTag'" @click="upLoadVisible = true">上传</a-button>
              <a-button v-if="data.id === 'drawingTag'" @click="tagVisible = true">新增</a-button>
            </div>
            <div v-if="data.id !== 'drawingTag'">
              <div class="lately-solution">
                <div class="solution-item" v-for="item in data.children" :key="item.id">
                  <div class="thumbnail">
                    <img
                      :src="
                        item.img
                          ? `${ossPathUrl}/${item.solutionThumbnail}`
                          : require('@/assets/workbench/sol.png')
                      "
                      alt=""
                    />
                    <a-dropdown :trigger="['click']">
                      <a class="ant-dropdown-link" @click.stop>
                        ...
                      </a>
                      <a-menu slot="overlay">
                        <a-menu-item key="1" v-if="data.id === 'dwgFrame'">
                          <a @click="_goEditDetails(item.id)">编辑</a>
                        </a-menu-item>
                        <a-menu-item key="2" v-if="data.id === 'dwgFrame'">
                          <a @click="_goCopyDetails(item)">复制</a>
                        </a-menu-item>
                        <a-menu-item key="3">
                          <a-popconfirm title="确定删除吗?" @confirm="() => _handleDeleteNode(item.id, 'details')" placement="bottom">
                            <a>删除</a>
                          </a-popconfirm>
                        </a-menu-item>
                        <a-menu-item key="4">
                          <template>
                            <a-modal
                              class="template-edit"
                              centered
                              width="500px"
                              title="重命名"
                              :visible="isReNameVisible"
                              @ok="_reName(item, 'details')"
                              @cancel="isReNameVisible = false"
                            >
                              <a-form-model-item label="名称" prop="prevName">
                                <a-input v-model="prevName" @change="(e) => prevName = e.target.value" />
                              </a-form-model-item>
                            </a-modal>
                          </template>
                          <a @click="isReNameVisible = true, prevName = item.name">重命名</a>
                        </a-menu-item>
                      </a-menu>

                    </a-dropdown>
                  </div>
                  <span>{{ item.name }}</span>
                  <a-modal
                    centered
                    width="1000px"
                    title="编辑"
                    :visible="iFrameVisible"
                    @cancel="_cancelIframe()"
                    :footer="null"
                  >
                    <iframe :src="`${resourceUrl}`" width="950" height="700" scrolling="auto" frameborder="0"> </iframe>
                  </a-modal>
                </div>
              </div>
            </div>
            <div v-if="data.id === 'drawingTag'">
              <a-table :dataSource="tagDataSource" :columns="columns">
                <template slot="operation" slot-scope="text, record">
                  <span style="marginRight: 10px">
                    <a-popconfirm title="是否要删除此行？" @confirm="_removeRow(record)"><a>删除</a></a-popconfirm>
                  </span>

                  <span>
                    <a @click="_editRow(record)">编辑</a>
                  </span>
                </template>
              </a-table>
            </div>
          </a-tab-pane>

        </a-tabs>

      </div>

    </div>

    <a-modal
      centered
      width="500px"
      title="新增"
      :visible="tagVisible"
      @ok="_handleAddTagOk()"
      @cancel="tagVisible = false"
    >
      <div>
        <a-form
          layout="horizontal"
          ref="formRef"
          :model="tagFormState"
          :rules="rules"
        >
          <a-form-model-item label="key">
            <a-input v-model="tagFormState.tagKey" />
          </a-form-model-item>
          <a-form-model-item label="value">
            <a-input v-model="tagFormState.tagValue" />
          </a-form-model-item>
        </a-form>
      </div></a-modal>

    <a-modal
      centered
      width="500px"
      title="上传"
      :visible="upLoadVisible"
      @ok="_handleUploadOk()"
      @cancel="upLoadVisible = false"
    >
      <a-upload-dragger
        v-model="fileList"
        :file-list="fileList"
        accept=".dwg"
        name="file"
        action=""
        :before-upload="_beforeUpload"
        @change="_handleChange"
      >
        <p class="ant-upload-drag-icon">
          <inbox-outlined></inbox-outlined>
        </p>
        <p class="ant-upload-text">将图框模板拖至此处，或点击上传</p>
        <p class="ant-upload-hint">
          297mm×210mm
        </p>
      </a-upload-dragger>
    </a-modal>
    <a-modal
      class="template-edit"
      centered
      width="500px"
      title="新增项目"
      :visible="isProjectEdit"
      @ok="_saveProjectResource()"
      @cancel="_close(null)"
    >
      <div>
        <a-form
          layout="horizontal"
          ref="formRef"
          :model="formState"
          :rules="rules"
        >
          <a-form-model-item label="名称" prop="projectName">
            <a-input v-model="formState.projectName" />
          </a-form-model-item>
        </a-form>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { savePartResource, getResourceByCondition, getResourceByPId, delResourceByIds, editResourceTreeNodeName, getResourceByIds } from '@/api/api'
import { UploadFileService } from '@/utils/oss/upload_service.ts'
import store from '@/store/'
import { message } from 'ant-design-vue'
import { getAction } from '@/api/manage'

export default {
    components: {
    },
    data () {
        return {
            isProjectEdit: false,
            curProjectId: '', // 1 选中项目id
            curProjectName: '',
            step: 0,
            formState: {
              projectName: ''
            },
            projectData: [],
            tabLabels: [
              {
                name: '图框库',
                id: 'dwgFrame',
                children: []
              },
              {
                name: '模板库',
                id: 'dwgTemplate',
                children: []
              },
              {
                name: '标签库',
                id: 'drawingTag',
                children: []
              }
            ],
            fileList: [],
            activeKey: 'dwgFrame',
            iFrameVisible: false,
            resourceUrl: '',
            isReNameVisible: false,
            prevName: '',
            upLoadVisible: false,
            tagFormState: {
              tagKey: '',
              tagValue: ''
            },
            tagDataSource: [],
            columns: [
              {
                title: 'key',
                dataIndex: 'tagKey',
                key: 'tagKey'
              },
              {
                title: 'value',
                dataIndex: 'tagValue',
                key: 'tagValue'
              },
              {
                title: '操作',
                dataIndex: 'operation',
                scopedSlots: { customRender: 'operation' }
              }
            ],
            curTagId: '',
            tagVisible: false
        }
    },
    mounted() {
      this._initProjectInfos()
    },
    methods: {
      //  根据条件查询
      async getDataByCondition(params) {
        const data = await getResourceByCondition(params)
        if (data.code !== 200) {
          message.error(data.message)
          return
        }
        return data
      },
      // 新增资源
      async addResource(params) {
        const res = await savePartResource(params)
        if (res.code !== 200) {
          message.error(res.message)
          return
        }
        return res
      },
      async getDataByPId(params) {
        const res = await getResourceByPId(params)
        if (res.code !== 200) {
          message.error(res.message)
          return
        }
        return res
      },
      // 项目列表
      async _initProjectInfos() {
        const res = await this.getDataByCondition({
          resourceCode: 'dwgProjectLibrary',
          props: {
            dwgProjectLibraryUserId: store.getters.userInfo.id
          }
        })
        this.projectData = res.result
      },
      // 点项目进库，库列表
      async _goProjectDetails(id, name) {
         this.curProjectId = id
        this.curProjectName = name
        for (const label of this.tabLabels) {
          let props = {}
          if (label.id === 'dwgFrame') {
            props = {
              dwgProjectLibraryUserId: store.getters.userInfo.id,
              dwgFrameProjectId: id
            }
          } else if (label.id === 'dwgTemplate') {
            props = {
              dwgProjectLibraryUserId: store.getters.userInfo.id,
              dwgTemplateProjectId: id
            }
          }
          const data = await this.getDataByCondition({
            resourceCode: label.id,
            pid: this.curProjectId,
            props
          })
          label.children = data.result
          if (label.id === 'drawingTag') {
            this.tagDataSource = data.result.map((res, index) => {
              return {
                key: index,
                tagKey: res.name,
                tagValue: res.value,
                id: res.id
              }
            })
          }
        }
        this.step = 1
      },

// 新增项目保存
    async _saveProjectResource() {
      const pid = '996853464590995456'
     await this.addResource({
        name: this.formState.projectName,
        pid,
        resourceCode: 'dwgProjectLibrary',
        type: 'folder',
        properties: { dwgProjectLibraryUserId: store.getters.userInfo.id, dwgProjectLibraryPublicFlag: false }
      })
      message.success('新增成功')
      this.isProjectEdit = false
      await this._initProjectInfos()
      this.formState = {
        projectName: ''
      }
    },
     _close() {
      this.isProjectEdit = false
    },

    _beforeUpload(file) {
      const { name } = file
      if (!name.endsWith('.dwg')) {
          message.error('请上传dwg文件')
      }
      return false
    },
    _handleChange(info) {
      const validFile = info.fileList.filter((f) => f.name.endsWith('.dwg'))
      this.fileList = validFile
    },

    _handleTabChange(val) {
      this.activeKey = val
    },

    async _handleUploadOk() {
        const loading = message.loading('上传中...', 0)
        const ossRes = await Promise.all(
            this.fileList.map((file) => UploadFileService.uploadFile2(file.originFileObj))
        )
        const params = []
        ossRes.forEach((data, index) => {
            const file = this.fileList[index]
            const { fileAddress } = data
            params.push({ ossPath: fileAddress, file })
        })
        if (params.length) {
            const addRes = await Promise.allSettled(
                params.map((param) => {
                    const fileNames = param.file.name.split('.')
                    const prefix = fileNames.slice(0, Math.max(1, fileNames.length - 1)).join('.')
                    return this._addNewResource(this.curProjectId, prefix, param.ossPath)
                })
            )
            addRes.forEach((data, index) => {
                const param = params[index]
                if (data.status === 'fulfilled' && data.value) {
                    message.success(`上传${param.file.name}成功`)
                    this.upLoadVisible = false
                    this._goProjectDetails(this.curProjectId, this.curProjectName)
                } else {
                    message.error(`上传${param.file.name}失败`)
                    this.upLoadVisible = false
                }
            })
        }
        loading()
        this.fileList = []
    },

     async _getResourceByIds(ids) {
        const MAX_ID_COUNT = 100
        const requestTimes = Math.ceil(ids.length / 100)
        if (requestTimes === 1) {
            const resourceIds = ids.join(',')
            const { result, code, msg } = await getAction('/doMistServer/part/getPartsByResourceIds', {
                resourceIds
            })
            if (code !== 200) {
                throw new Error(`资源请求错误: ${msg}`)
            }
            return result
        }
        const results = []
        const slices = []
        for (let i = 0; i < requestTimes; i++) {
            const slice = ids.slice(i * MAX_ID_COUNT, MAX_ID_COUNT * (i + 1))
            slices.push(slice)
        }
        const resources = await Promise.allSettled(
            slices.map((resourceIds) =>
                getAction('/doMistServer/part/getPartsByResourceIds', {
                    resourceIds
                })
            )
        )
        resources.forEach((res) => {
            if (res.status === 'fulfilled' && res.value.result) {
                const { result } = res.value
                if (Array.isArray(result)) {
                    results.push(...result)
                } else {
                    results.push(result)
                }
            }
        })
        return results
    },

    async _addNewResource(pid, name, fileAddress) {
        try {
          let res
          this.activeKey === 'dwgFrame'
              ? res = await this.addResource({
              name,
              pid,
              resourceCode: 'dwgFrame',
              type: 'file',
              properties: { dwgFrameFileAddress: fileAddress, dwgFrameProjectId: pid }
            })
              : res = await this.addResource({
              name,
              pid,
              resourceCode: 'dwgTemplate',
              type: 'file',
              properties: { dwgTemplateFileAddress: fileAddress, dwgTemplateProjectId: pid }
            })

            if (res && res.result) {
              let i = 60
              while (i > 0) {
                await this._sleep(500)
                  i--
                  const resourceIds = [res.result]
                const parseResult = await this._getResourceByIds(resourceIds)
                if (this.activeKey === 'dwgFrame' && parseResult[0].dwgFrameParsed) {
                    message.success('解析成功')
                    return true
                } else if (this.activeKey === 'dwgTemplate' && parseResult[0].dwgTemplateParsed) {
                    message.success('解析成功')
                    return true
                }
              }
              message.error('图框解析失败')
              return false
            }
        } catch (error) {
            console.error(error)
        }
        return false
    },

    _sleep(time) {
        return new Promise((resolve) => setTimeout(resolve, time))
    },

    async _handleDeleteNode(id, flag) {
      const { code } = await delResourceByIds({ ids: [id] })
      if (code === 200) {
        message.success('删除成功')
        if (flag === 'project') {
          this._initProjectInfos()
        }
        if (flag === 'details') {
          this._goProjectDetails(this.curProjectId, this.curProjectName)
        }
      }
    },
    async _handleEditNode(item, flag) {
      const { code } = await editResourceTreeNodeName({
        id: item.id,
        resourceCode: 'dwgProjectLibrary',
        properties: { dwgProjectLibraryUserId: store.getters.userInfo.id, dwgProjectLibraryPublicFlag: flag }
      })
      if (code === 200) {
        message.success('操作成功')
        this._initProjectInfos()
      }
    },
    async _reName(item, flag) {
      const { code } = await editResourceTreeNodeName({
        id: item.id,
        name: this.prevName
      })
      if (code === 200) {
        message.success('操作成功')
        this.isReNameVisible = false
        if (flag === 'project') {
          this._initProjectInfos()
        }
        if (flag === 'details') {
          this._goProjectDetails(this.curProjectId, this.curProjectName)
        }
      }
    },

    _goEditDetails(id) {
      this.iFrameVisible = true
      this.resourceUrl = `${window.ENV_CONFIG['resourceUrl']}/?frameId=${id}`
    },

    async _goCopyDetails(item) {
      await this.addResource({
        name: `${item.name}(1)`,
        pid: this.curProjectId,
        resourceCode: 'dwgFrame',
        type: 'file',
        properties: { dwgFrameFileAddress: item.dwgFrameFileAddress, dwgFrameProjectId: this.curProjectId }
      })
      message.success('复制成功')
      this._goProjectDetails(this.curProjectId, this.curProjectName)
    },

    _cancelIframe () {
      this.iFrameVisible = false
      this._goProjectDetails(this.curProjectId, this.curProjectName)
    },
    // 编辑资源
      async editResource(params) {
        const res = await savePartResource(params)
        if (res.code !== 200) {
          message.error(res.message)
          return
        }
        return res
      },

    async _handleAddTagOk() {
      if (this.curTagId) {
        const { code } = await editResourceTreeNodeName({
        id: this.curTagId,
        name: this.tagFormState.tagKey,
        value: this.tagFormState.tagValue
        })
        if (code === 200) {
          message.success('操作成功')
          this.curTagId = ''
        } else {
          message.error('编辑失败')
        }
      } else {
        await this.addResource({
          name: this.tagFormState.tagKey,
          value: this.tagFormState.tagValue,
          pid: this.curProjectId,
          resourceCode: 'drawingTag',
          type: 'file'
        })
        message.success('修改成功')
        this.curTagId = ''
      }
      this.tagVisible = false
      this.tagFormState.tagKey = ''
      this.tagFormState.tagValue = ''
      const data = await this.getDataByCondition({
        resourceCode: 'drawingTag',
        pid: this.curProjectId
      })
      this.tagDataSource = data.result.map((res, index) => {
        return {
          key: index,
          tagKey: res.name,
          tagValue: res.value,
          id: res.id
        }
      })
    },

    _editRow(data) {
      this.tagVisible = true
      this.tagFormState.tagKey = data.tagKey
      this.tagFormState.tagValue = data.tagValue
      this.curTagId = data.id
    },

    async _removeRow(data) {
      const { code } = await delResourceByIds({ ids: [data.id] })
      if (code === 200) {
        message.success('删除成功')
        const data = await this.getDataByCondition({
        resourceCode: 'drawingTag',
        pid: this.curProjectId
      })
      this.tagDataSource = data.result.map((res, index) => {
        return {
          key: index,
          tagKey: res.name,
          tagValue: res.value,
          id: res.id
        }
      })
      }
    }

  }
}
</script>
<style lang="less">
@import './index.less';
</style>
